export default {
	title: 'إضافة إجازة',
	'title-permission': 'إضافة إذن',

	addVacation: {
		forDay: 'يومية',
		forHour: 'ساعية',
		withSalary: 'مع راتب',
		withOutSalary: 'بلا راتب',
		noSalary: 'بلا راتب',
		type: 'النوع',
		time: 'الوقت',
		cause: 'السبب',
		duration: 'المدة',
		minutes: 'دقائق',
		min: 'د',
	},
};
